import { Field, TextOutput } from 'Components/Core';
import { withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { ListFieldSection } from 'Components/Layout';
import { IWorksheetComponent } from 'Components/Worksheets/Core/types';
import React from 'react';

let SievingWashResultsSection: React.FC<IWorksheetComponent> = () => (
  <ListFieldSection>
    <Field input={<TextOutput />} name="Masses.WashedDryMass" />
    <Field input={<TextOutput />} name="Results.PercentPassingWashingSieve" />
  </ListFieldSection>
);

SievingWashResultsSection = withInjectedProps(SievingWashResultsSection);

export default SievingWashResultsSection;
export { SievingWashResultsSection as ResultsSection };
